import { render, staticRenderFns } from "./nianduxuanze.vue?vue&type=template&id=2622c7e6&scoped=true"
import script from "./nianduxuanze.vue?vue&type=script&lang=js"
export * from "./nianduxuanze.vue?vue&type=script&lang=js"
import style0 from "./nianduxuanze.vue?vue&type=style&index=0&id=2622c7e6&prod&lang=css"
import style1 from "./nianduxuanze.vue?vue&type=style&index=1&id=2622c7e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2622c7e6",
  null
  
)

export default component.exports